import React from 'react';

import IconToggle from '../../../../library/icon-toggle/icon-toggle';
import Typography from '../../../../library/typography/typography';
import { SnowflakeRegularIcon } from '../../../../shared/icons/icons';

import {
  useAemContent,
  useTreadwellPreferences
} from '../../../../shared/hooks/hooks';

import {
  AEM_CONTENT_IDS,
  AEM_CONTENT_PAGE_IDS
} from '../../../../shared/constants/cms';

import './winter-toggle.scss';

interface WinterToggleProps {
  onToggle: () => void;
}

function WinterToggle(props: WinterToggleProps) {
  const { onToggle } = props;

  const { treadwellPreferences } = useTreadwellPreferences();

  const { showWinterTires } = treadwellPreferences || {};

  const { aemTooltipsContent } = useAemContent(
    AEM_CONTENT_PAGE_IDS.treadwellPlp
  );

  const toggleCopy = aemTooltipsContent?.[AEM_CONTENT_IDS.toggleCopy];

  return (
    <div styleName="container">
      <IconToggle
        ariaLabelledBy="winter-toggle"
        icon={
          <SnowflakeRegularIcon
            styleName={`toggle-icon ${
              showWinterTires ? 'toggle-icon--checked' : ''
            }`}
          />
        }
        isEnabled={Boolean(showWinterTires)}
        label={
          <Typography
            styleName={`winter-toggle-title ${
              showWinterTires ? 'winter-toggle-title--checked' : ''
            }`}
          >
            {toggleCopy?.title || 'Shop Winter Tires'}
          </Typography>
        }
        onToggle={onToggle}
      />
    </div>
  );
}

export default WinterToggle;
